// This file is updated using the cli
// No not modify!
import React from 'react';
const Icon = (props) => {
    return (React.createElement("svg", Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 23 24", width: "23", height: "24" }, props),
        React.createElement("g", { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
            React.createElement("g", null,
                React.createElement("path", { d: "M720,771 C721.104569,771 722,771.895431 722,773 L722,783 L716,783 L716,773 C716,771.895431 716.895431,771 718,771 L720,771 Z M729,766 C730.104569,766 731,766.895431 731,768 L731,783 L725,783 L725,768 C725,766.895431 725.895431,766 727,766 L729,766 Z M737,759 C738.104569,759 739,759.895431 739,761 L739,783 L733,783 L733,761 C733,759.895431 733.895431,759 735,759 L737,759 Z", transform: "translate(-716 -759)" })))));
};
Icon.displayName = 'BarChart23x24';
export default Icon;
//# sourceMappingURL=BarChart23x24.js.map